module.exports = __webpack_public_path__ + "img/ix35.fc90a97f.png";